import React, { useState, useRef, Component } from "react";
import { useReactToPrint } from "react-to-print";
import { useHistory } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import CssBaseline from "@material-ui/core/CssBaseline";
import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
import PrintIcon from "@material-ui/icons/Print";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import HomeIcon from "@material-ui/icons/Home";
import Grid from "@material-ui/core/Grid";
import { useStylesSpDial } from "../../../St/Reviews/UseStyle";
import ShareIcon from "@material-ui/icons/Share";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Notes from "@material-ui/icons/Notes";
import RevInvCon from "./RevInvCon";
import { handleDownloadGenratePdf, shareDataPdf, styleContPrint } from "../ShareFunctionsPrint";

class ComponentToPrint extends Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        const style = {
            backgroundColor: "#fff",
            color: "#000",
        };
        return (
            <Typography component="div" style={style}>
                <RevInvCon typeInv={this.props.typeInv} openDelevery={this.props.openDelevery}
                    locInv={this.props.locInv} />
            </Typography>
        );
    }
}
const InvoicesPrint = (props) => {
    const { typeInv, locInv, handNewInv, keepFocus, isFocus } = props;
    const componentRef = useRef();
    const reportDownloadRef = useRef();
    const clasSp = useStylesSpDial();
    const [openDelevery, setOpenDelevery] = useState(false);

    const [open, setOpen] = useState(true);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(true);
    };
    let his = useHistory();
    const printDev = async () => {
        if (locInv?.Delivery === 1 && !openDelevery) {
            printDelevery();
        }
    };
    const printDelevery = async () => {
        setOpenDelevery(true);
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        onAfterPrint: () => printDev(),
    });
    const [childMountCount, setChildMountCount] = useState(0);
    const handleChildMountComplete = () => {
        setChildMountCount((prevCount) => prevCount + 1);
    };
    const docNamePdf = openDelevery ? "DeleveryNotes.pdf" : "Invoice.pdf";
    const docName = openDelevery ? "DeleveryNotes" : "Invoice";

    const back = async (path) => {
        if (path == true) {
            his.push({ pathname: "/" });
        } else {
            if (openDelevery) { setOpenDelevery(false); }
            else {
                if (isFocus) { try { await keepFocus(); } catch { } }
                await handNewInv();
            }
        }
    };
    const shareData = async () => {
        shareDataPdf(reportDownloadRef, docNamePdf);
    };
    const handleGeneratePdf = async () => {
        handleDownloadGenratePdf(docName, reportDownloadRef)
    };
    const actions = [
        {
            icon: (
                <PrintIcon className={clasSp.ico} onClick={handlePrint} />
            ),
            name: "طباعـة",
        },
        {
            icon: (
                <Notes className={clasSp.ico} onClick={printDelevery} />
            ),
            name: "delevery Notes",
            hidden: openDelevery,
        },
        {
            icon: (
                <ArrowDownward className={clasSp.ico} onClick={handleGeneratePdf} />
            ),
            name: "تنزيل",
        },
        {
            icon: <ShareIcon className={clasSp.ico} onClick={shareData} />,
            name: "مشاركة",
        },
        {
            icon: (
                <ArrowBackIcon className={clasSp.ico} onClick={() => back(false)} />
            ),
            name: "رجـوع",
        },
    ];

    return (
        <div className={clasSp.root}
        >
            <Grid item container justifyContent="center" style={styleContPrint}>
                <Grid item style={{ backgroundColor: "#fff", width: "21cm" }}>
                    <CssBaseline />
                    <div
                        ref={reportDownloadRef}
                        lang={"ar"}
                        style={{
                            fontFamily: "Helvetica",
                            fontStyle: "bold",
                            letterSpacing: "normal",
                        }}
                    >
                        <ComponentToPrint
                            ref={componentRef}
                            onUnmountComplete={handleChildMountComplete}
                            typeInv={typeInv}
                            openDelevery={openDelevery}
                            locInv={locInv}
                        />
                    </div>
                </Grid>
            </Grid>

            <SpeedDial
                ariaLabel="SpeedDial openIcon example"
                className={clasSp.speedDial}
                hidden={false}
                icon={
                    <SpeedDialIcon openIcon={<HomeIcon />} onClick={() => back(true)} />
                }
                onClose={handleClose}
                onOpen={handleOpen}
                open={open}
            >
                {actions.filter(action => !action.hidden).map((action, i) => (
                    <SpeedDialAction
                        key={i}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={handleClose}
                    />
                ))}
            </SpeedDial>
        </div>
    );
};

export default InvoicesPrint;
